module.exports = __webpack_public_path__ + "35339101c758e6af82681765a919e173.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/150.png
// module id = 1745
// module chunks = 2